import { cloneDeep } from '@sama/micro-dash';
import { addPoints } from '../../../../shared/misc-utilities/point-utils';
import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { SingleSubpointTranslationHelper } from '../../tools/edit/single-subpoint-translation-helper';

export class CuboidSubpointTranslationHelper extends SingleSubpointTranslationHelper {
  protected override getMovableSubpointIndexes() {
    if (this.pointIndex === 2) {
      return [2, 4];
    } else {
      return [this.pointIndex];
    }
  }

  protected override movePoints(oldPoints: Point2D[], delta: Point2D) {
    const points = cloneDeep(oldPoints);
    points[this.pointIndex] = addPoints(points[this.pointIndex], delta);
    if (this.pointIndex === 2) {
      points[4][0] = points[this.pointIndex][0];
    }
    return points;
  }

  protected override validateDelta(
    points: Point2D[],
    delta: Point2D,
    pointIndexes: number[],
  ) {
    // fix me if you change this code
    // eslint-disable-next-line no-param-reassign -- fix me!
    delta = super.validateDelta(points, delta, pointIndexes);
    if (this.pointIndex === 4) {
      delta[0] = 0;
    }
    return delta;
  }
}
